export default __webpack_public_path__ + "static/media/teams.e9e22e30.svg";